import { useEffect } from 'react'

import { Fallback } from './Fallback'

interface Props {
  targetPath: string
}

export function ExternalRedirect({ targetPath }: Props) {
  const baseUrl = process.env.REACT_APP_CARRIER_GUIDE_URL

  useEffect(() => {
    window.location.replace(`${baseUrl}${targetPath}?source=carrier-web`)
  }, [baseUrl, targetPath])

  return <Fallback />
}
